import React from "react";
import { Link } from "../../../shared/components/Link/Link";
import { useMatchData } from "../../utils";
import { RightArrowIcon } from "../../../shared/svg/RightArrowIcon/RightArrowIcon";
import { StyledChevron } from "./StyledChevron";

function Chevron() {
  const { matchPageUrl, matchOptaId } = useMatchData();

  if (matchOptaId <= 0) {
    return null;
  }

  return (
    <StyledChevron>
      <Link url={matchPageUrl} rel="noopener noreferrer">
        <RightArrowIcon width={5} height={10} />
      </Link>
    </StyledChevron>
  );
}

export default Chevron;
